<template>
    <Paper class="boxControl">
        <el-row type="flex" class="boxControl-search row-bg" justify="space-between">
            <el-col :span="22">
                <el-row>
                    <el-col class="sn-search-item">
                        <el-input v-model="searchData['boxBarcodeNo']" placeholder="大箱条码"></el-input>
                    </el-col>
                    <el-col class="sn-search-item">
                        <el-input v-model="searchData['barcodeNo']" placeholder="小箱条码"></el-input>
                    </el-col>
                    <div class="search-margin">
                        <el-button type="primary" :loading="searchLoading" size="mini" @click="searchChange" icon='el-icon-search'>
                            {{$translate('lang.E3202101260004', { defaultText: '查 询' })}}
                        </el-button>
                        <el-button class="sn-search-reset-button" @click="restSearchChange" size="mini">
                            {{$translate('lang.E3202101260009', { defaultText: '重 置' })}}
                        </el-button>
                        <div class="exportBt">
                            <mExport :url='listExport.exportUrl' :params='listExport.exportParams' :name='listExport.exportName' :type='listExport.type' :listData='tableData'
                                :exportFlag='listExport.exportFlag' :titleText='listExport.titleText'>
                            </mExport>
                        </div>

                    </div>

                </el-row>
            </el-col>
        </el-row>
        <MTable :config="config" :pageTotal="pageTotal" :tableData="tableData" @pageChange="pageChange" @sizeChange="sizeChange">
        </MTable>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import MTable from '../../../components/IdentityComponent/Main';
import { boxRelation } from '../../../api/lcbsManagement.js';
import { config } from './Config';
import mExport from '../component/export';
import moment from 'moment';
// moment(new Date()).format('YYYY-MM-DD')
export default {
    name: 'boxControlGroup',
    components: { Paper, MTable, mExport },
    data() {
        return {
            config: config,
            searchData: {},
            searchLoading: false,
            pageNo: 1,
            pageSize: 10,
            pageTotal: 0,
            tableData: [],
            listExport: {
                // exportUrl: '/api-sn/lbcs/bcBarcodeCheckDtls/export',
                exportUrl: '/api-sn/bcBarcodeMatchs/export',
                exportName: '',
                exportParams: {},
                titleText: this.$translate('lang.E3202102220027', { defaultText: '导出Excel' }),
                exportFlag: 1
            }
        };
    },
    created() {
        this.listExport.exportName = '大小箱条码导出查询' + '_' + moment(new Date()).format('YYYYMMDD') + '.xls';
    },
    methods: {
        searchChange() {
            this.pageNo = 1;
            this.loadData();
        },
        restSearchChange() {
            this.searchData = this.$options.data.call(this).searchData;
        },
        newGroup() {
            this.formData = {};
            this.searchIndex = true;
        },
        loadData() {
            const params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                ...this.searchData
            };
            // 导出按钮入参
            this.listExport.exportParams = { ...this.searchData };
            this.searchLoading = true;
            boxRelation(params).then(res => {
                if (res && +res.code === 0) {
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                }
            }).finally(() => {
                this.searchLoading = false;
            });
        },
        pageChange(data) {
            this.pageNo = data;
            this.loadData();
        },
        sizeChange(data) {
            this.pageSize = data;
            this.loadData();
        }
    }
};
</script>
<style lang="less">
.boxControl {
    .boxControl-search {
        margin-bottom: 20px;
    }
    .exportBt {
        display: inline-block;
        margin-left: 10px;
    }
}
</style>
